const addLoadingStatusSearchOnMobile = () => {
    let searchBarMobile = document.querySelector('.search-bar.is-mobile');
    let searchSpinnerMobile = searchBarMobile?.querySelector('.search-spinner');
    let clearButton = searchBarMobile?.querySelector('.clear-search');

    searchSpinnerMobile?.classList.remove('hidden');
    clearButton?.classList.add('hidden');
};

export default addLoadingStatusSearchOnMobile;